"use strict";
/**
 * Internal types
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadMode = void 0;
// Values are the exact same as from the @modbox/s3-uploads-server UploadMode enum
var UploadMode;
(function (UploadMode) {
    UploadMode["Multipart"] = "Multipart";
    UploadMode["Single"] = "Single";
})(UploadMode = exports.UploadMode || (exports.UploadMode = {}));
